// @ts-nocheck
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Tile, Grid, Column, Stack, Heading } from '@carbon/react';
import styles from './LoginPage.module.scss';
import { Security, CheckmarkFilled, Book, Earth } from '@carbon/icons-react';

import { useAuthStore } from '../../store/authStore';
import LoginForm from '../../components/auth/LoginForm';
import type { IAuthenticationResponse, IAuthError } from '../../../../shared/interfaces/auth';

function LoginPage() {
  const navigate = useNavigate();
  const { setUser, setError, error, clearError } = useAuthStore();

  const handleLoginSuccess = (response: IAuthenticationResponse) => {
    // Store user in auth store
    setUser(response.user);
    clearError();

    // Navigate based on user role
    const roleBasedRoute = {
      platform_admin: '/admin',
      admin: '/admin',
      teacher: '/teacher',
      student: '/student',
      parent: '/parent',
      principal: '/dashboard',
      district_admin: '/admin',
      individual: '/dashboard',
    };

    const targetRoute = roleBasedRoute[response.user.role] || '/dashboard';

    // Navigation happens immediately since LoginForm now verifies token storage
    // Token storage is guaranteed to be complete before onSuccess callback is called
    navigate(targetRoute, { replace: true });
  };

  const handleLoginError = (error: IAuthError) => {
    // LoginForm component now handles error display inline
    // No need to set global error state which triggers toast notifications
  };

  return (
    <div className={styles.loginContainer}>
      <Grid narrow>
        <Column sm={4} md={6} lg={6} xlg={4} max={4}>
          <Tile className={styles.loginTile}>
            <Stack gap={6}>
              {/* Header Section */}
              <div className={styles.centeredText}>
                <Heading className="cds--productive-heading-04">Welcome to Sigma08</Heading>
                <p className={`cds--body-01 ${styles.subtitle}`}>Your AI Learning Companion for Every Stage</p>
              </div>

              {/* Use the working LoginForm component with controlled inputs */}
              <LoginForm
                onSuccess={handleLoginSuccess}
                onError={handleLoginError}
                showRegistrationLink={false}
                showForgotPassword={true}
              />

              {/* Footer Section */}
              <div className={styles.footer}>
                <div className={`cds--caption-01 ${styles.footerContent}`}>
                  <div className={styles.footerFeature}>
                    <Security size={16} />
                    <span>Your family's privacy is protected with industry-leading security</span>
                  </div>
                  <div className={styles.footerFeatures}>
                    <div className={styles.footerFeature}>
                      <CheckmarkFilled size={16} />
                      <span>FERPA & COPPA Compliant</span>
                    </div>
                    <div className={styles.footerFeature}>
                      <Book size={16} />
                      <span>Curriculum Adaptive</span>
                    </div>
                    <div className={styles.footerFeature}>
                      <Earth size={16} />
                      <span>Multi-language Support</span>
                    </div>
                  </div>
                </div>
              </div>
            </Stack>
          </Tile>
        </Column>
      </Grid>
    </div>
  );
}

export default LoginPage;
